/**
 * GameCommands - handles command execution
 * This is a massive module with a large switch statement handling all game commands
 */

import { Command } from '../models/Command';
import { Condition } from '../models/Condition';
import { Finder } from '../utils/Finder';
import { Globals } from '../core/Globals';
import { Settings } from '../core/Settings';
import { gameController } from '../core/GameController';
import { GameConditions } from './GameConditions';
import { GameActions } from './GameActions';
import { GameTimers } from './GameTimers';
import { AdvancedActions } from './AdvancedActions';
import { Interactables, GetCustomChoiceAction, SetVariable, SetCustomProperty, GetArrayIndex, getObjectClass, objectContainsObject, objecttostring, objectToString, evalJankyJavascriptAsync, evalLegacyCustomPropertyJavascriptAsync, RefreshPictureBoxes, AddTextToRTF, PauseGameAsync, showImage, SetPortrait, imagePath, imageUrl, movePlayerToRoom, movePlayerToRoomAsync, RoomChange, RoomChangeAsync, SetExits, SetupStatusBars, varArrayCheck } from '../utils/Utilities';
import { SelfObjectGuid, CurrentRoomGuid, VoidRoomGuid } from '../utils/Constants';
import { PerformTextReplacements } from '../utils/TextHandler';
import { $dom, css } from '../utils/DOM';

declare const TheGame: any;

// Forward declarations
declare namespace GameUI {
    function refreshInventory(): void;
    function refreshRoomObjects(): void;
    function refreshCharacters(): void;
    function refreshPanelItems(): void;
    function playBgMusic(path: string | null): void;
    function playSoundEffect(path: string): void;
    function showMessage(type: string, options: any): void;
    function hideGameElements(): void;
    function setCmdInputForCustomChoices(title: string, command: any): void;
    function showTextMenuChoice(title: string): void;
    function clearCmdInputChoices(): void;
    function addCharacterOptions(action?: any, withObjects?: boolean): void;
    function addObjectOptions(): void;
    function addCmdInputChoice(text: string, obj: any): void;
    function setCmdInputMenuTitle(action: any, title: string): void;
}
declare namespace Logger {
    function logExecutingCommand(command: Command, part2: string, part3: string, part4: string): void;
}
declare function GetGameImage(imageName: string): any;
declare function SetRagsObjectsFromJavascript(result: any): void;
declare function RestoreLoopObject(): void;
declare var mainImageExtraLayers: string[];
declare class command {
    cmdtype: string;
    CustomChoices: any[];
}
declare class ragscondition {
    Checks: any[];
}

export const GameCommands = {
    runSingleCommandAsync: async function (commandBeingProcessed: Command, part2: string, part3: string, part4: string, cmdtxt: string): Promise<boolean | undefined> {
        if ((commandBeingProcessed as any).IsAdvanced && (Settings as any).debugEnabled) {
            // eslint-disable-next-line no-console
            console.debug('[AdvancedAction] runSingleCommand', commandBeingProcessed.cmdtype, {
                part2,
                part3,
                part4,
                cmdtxt,
            });
        } else if ((Settings as any).debugEnabled) {
            console.debug(commandBeingProcessed.cmdtype, part2, part3, part4, cmdtxt, commandBeingProcessed);
        }

        const objectBeingActedUpon = (Globals as any).objectBeingActedUpon;
        switch (commandBeingProcessed.cmdtype) {
            case "CT_LAYEREDIMAGE_ADD": {
                function uniqueArray(array: string[]): string[] {
                    const hsh: { [key: string]: boolean } = {};
                    for (let i = 0; i < array.length; i++) {
                        hsh[array[i]] = true;
                    }
                    return Object.keys(hsh);
                }

                const temp = (window as any).GetGameImage?.(part2);
                if (temp != null) {
                    const layeredImagesArray = temp.LayeredImages[0].split(',');
                    layeredImagesArray.push(part3);
                    const filtered = layeredImagesArray.filter((image: string) => {
                        return !!image;
                    });

                    temp.LayeredImages[0] = uniqueArray(filtered).join(',');
                    (window as any).RefreshPictureBoxes?.();
                }
                break;
            }
            case "CT_LAYEREDIMAGE_REMOVE": {
                const temp = (window as any).GetGameImage?.(part2);
                if (temp != null) {
                    let idx = temp.LayeredImages[0].toLowerCase().indexOf(part3.toLowerCase());
                    if (idx > -1) {
                        let endidx = temp.LayeredImages[0].indexOf(",", idx + 1);
                        if (idx > 0)
                            idx -= 1;
                        if (endidx == -1)
                            temp.LayeredImages[0] = temp.LayeredImages[0].slice(0, idx);
                        else
                            temp.LayeredImages[0] = temp.LayeredImages[0].slice(0, idx) +
                                temp.LayeredImages[0].slice(endidx);
                    }

                    (window as any).RefreshPictureBoxes?.();
                }
                break;
            }
            case "CT_LAYEREDIMAGE_REPLACE": {
                const temp = (window as any).GetGameImage?.(part2);
                if (temp != null) {
                    const idx = temp.LayeredImages[0].toLowerCase().indexOf(part3.toLowerCase());
                    if (idx > -1) {
                        const endidx = temp.LayeredImages[0].indexOf(",", idx + 1);

                        if (endidx == -1)
                            temp.LayeredImages[0] = temp.LayeredImages[0].slice(0, idx) + part4;
                        else
                            temp.LayeredImages[0] = temp.LayeredImages[0].slice(0, idx) + part4 +
                                temp.LayeredImages[0].slice(endidx);
                    }

                    //  RefreshPictureBoxes();
                }
                break;
            }
            case "CT_LAYEREDIMAGE_CLEAR": {
                const temp = (window as any).GetGameImage?.(part2);
                if (temp != null) {
                    temp.LayeredImages[0] = "";
                    (window as any).RefreshPictureBoxes?.();
                }
                break;
            }
            case "CT_ITEM_GETRANDOMGROUP": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const cheatFreezes = (window as any).cheatFreezes;
                    if (cheatFreezes && cheatFreezes.variables && cheatFreezes.variables[tempvar.varname]) {
                        break; // Variable is frozen
                    }
                    const items = Finder.objectGroup(part3);
                    if (items.length > 0) {
                        tempvar.sString = items[Math.floor(Math.random() * items.length)].name;
                        break;
                    }
                }
                if (tempvar) {
                    const cheatFreezes = (window as any).cheatFreezes;
                    if (!cheatFreezes || !cheatFreezes.variables || !cheatFreezes.variables[tempvar.varname]) {
                        tempvar.sString = "";
                    }
                }
                break;
            }
            case "CT_MM_GETRANDOMGROUP": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const cheatFreezes = (window as any).cheatFreezes;
                    if (cheatFreezes && cheatFreezes.variables && cheatFreezes.variables[tempvar.varname]) {
                        break; // Variable is frozen
                    }
                    const images = Finder.imageGroup(part3);
                    if (images.length > 0) {
                        tempvar.sString = images[Math.floor(Math.random() * images.length)].TheName;
                        break;
                    }
                }
                if (tempvar) {
                    const cheatFreezes = (window as any).cheatFreezes;
                    if (!cheatFreezes || !cheatFreezes.variables || !cheatFreezes.variables[tempvar.varname]) {
                        tempvar.sString = "";
                    }
                }
                break;
            }
            case "CT_Status_ItemVisibleInvisible": {
                if (!TheGame) break;
                for (let i = 0; i < TheGame.StatusBarItems.length; i++) {
                    const itm = TheGame.StatusBarItems[i];
                    if (itm.Name == part2) {
                        if (part3 == "Visible") {
                            itm.bVisible = true;
                        } else {
                            itm.bVisible = false;
                        }
                    }
                }
                break;
            }
            case "CT_DISPLAYITEMDESC": {
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        (window as any).AddTextToRTF?.(objectBeingActedUpon.description, "Black", "Regular");
                } else {
                    const tempobj = Finder.object(part2);
                    if (tempobj != null)
                        (window as any).AddTextToRTF?.(tempobj.description, "Black", "Regular");
                }
                break;
            }
            case "CT_LOOP_BREAK": {
                return true;
            }
            case "CT_EXPORTVARIABLE": {
                break;
            }
            case "CT_IMPORTVARIABLE": {
                break;
            }
            case "CT_VARIABLE_SET_RANDOMLY": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const randMin = parseInt(PerformTextReplacements(tempvar.dMin, null), 10);
                    const randMax = parseInt(PerformTextReplacements(tempvar.dMax, null), 10);
                    const randomValue = Math.floor(Math.random() * (randMax - randMin + 1) + randMin);

                    const index = GetArrayIndex(part2, 0);
                    const index1a = GetArrayIndex(part2, 1);
                    varArrayCheck(tempvar, index, 'CT_VARIABLE_SET_RANDOMLY');
                    const idx = typeof index === 'number' ? index : parseInt(String(index), 10);
                    const idx1a = typeof index1a === 'number' ? index1a : parseInt(String(index1a), 10);
                    if (idx == -1) {
                        tempvar.dNumType = randomValue;
                    } else {
                        if (idx1a != -1 && tempvar.VarArray)
                            tempvar.VarArray[idx][idx1a] = randomValue;
                        else if (tempvar.VarArray)
                            tempvar.VarArray[idx] = randomValue;
                    }
                }
                break;
            }
              case "CT_CANCELMOVE": {
                (Globals as any).bCancelMove = true;
                break;
            }
               case "CT_ACTION_CLEAR_CUSTOMCHOICE": {
                const cmd2 = part2;
                const cmds = cmd2.split(":");
                let tempact: any = null;
                if (cmds.length > 2) {
                    tempact = GetCustomChoiceAction(cmds[0], cmds[1], cmds[2]);
                } else if (cmds.length == 2) {
                    tempact = GetCustomChoiceAction(cmds[0], "", cmds[1]);
                }
                if (tempact != null) {
                    tempact.CustomChoices = [];
                }
                break;
            }
            case "CT_ACTION_ADD_CUSTOMCHOICE": {
                const cmd2 = part2;
                const cmds = cmd2.split(":");
                let tempact: any = null;
                if (cmds.length > 2) {
                    tempact = GetCustomChoiceAction(cmds[0], cmds[1], cmds[2]);
                } else if (cmds.length == 2) {
                    tempact = GetCustomChoiceAction(cmds[0], "", cmds[1]);
                }
                if (tempact != null) {
                    let bfound = false;
                    for (let i = 0; i < tempact.CustomChoices.length; i++) {
                        const str = tempact.CustomChoices[i];
                        if (str == cmdtxt) {
                            bfound = true;
                        }
                    }
                    if (!bfound) {
                        tempact.CustomChoices.push(cmdtxt);
                    }
                }
                break;
            }
            case "CT_ACTION_REMOVE_CUSTOMCHOICE": {
                const cmd2 = part2;
                const cmds = cmd2.split(":");
                let tempact: any = null;
                if (cmds.length > 2) {
                    tempact = GetCustomChoiceAction(cmds[0], cmds[1], cmds[2]);
                } else if (cmds.length == 2) {
                    tempact = GetCustomChoiceAction(cmds[0], "", cmds[1]);
                }
                if (tempact != null) {
                    for (let i = 0; i < tempact.CustomChoices.length; i++) {
                        if (tempact.CustomChoices[i] == cmdtxt) {
                            tempact.CustomChoices.splice(i, 1);
                            break;
                        }
                    }
                }
                break;
            }
            case "CT_SETPLAYERGENDER": {
                if (TheGame) TheGame.Player.PlayerGender = part2;
                break;
            }
            case "CT_PAUSEGAME": {
                AddTextToRTF("--------------------------------\r\n", "Black", "Bold");
                await PauseGameAsync();
                break;
            }
            case "CT_SETPLAYERNAME": {
                if (TheGame) TheGame.Player.Name = PerformTextReplacements(part4, null);
                break;
            }
            case "CT_DISPLAYPLAYERDESC": {
                if (TheGame) {
                    const val = PerformTextReplacements(TheGame.Player.Description, null);
                    (window as any).AddTextToRTF?.(val + "\r\n", "Black", "Regular");
                }
                break;
            }
            case "CT_ITEM_LAYERED_REMOVE": {
                const tempobj = Finder.object(part2);
                if (tempobj != null) {
                    const curtype = tempobj.locationtype;
                    const locname = tempobj.locationname;
                    let bOkayToWear = true;
                    let resultstring = "";
                    if (tempobj.LayeredZoneLevels && TheGame) {
                        for (let i = 0; i < tempobj.LayeredZoneLevels.length; i++) {
                            const str = tempobj.LayeredZoneLevels[i];
                            const Zonelevel = str.split(":");
                            for (let j = 0; j < TheGame.Objects.length; j++) {
                                const checkobj = TheGame.Objects[j];
                                if (checkobj.bWorn && checkobj.locationtype == curtype) {
                                    if (curtype == "LT_CHARACTER") {
                                        if (locname != checkobj.locationname)
                                            continue;
                                    }
                                    if (checkobj.LayeredZoneLevels) {
                                        for (let k = 0; k < checkobj.LayeredZoneLevels.length; k++) {
                                            const str2 = checkobj.LayeredZoneLevels[k];
                                            const checkZoneLevel = str2.split(":");
                                            if (tempobj.UniqueIdentifier != checkobj.UniqueIdentifier && checkZoneLevel[0] == Zonelevel[0]
                                                    && parseInt(checkZoneLevel[1], 10) >= parseInt(Zonelevel[1], 10)) {
                                                bOkayToWear = false;
                                                if (resultstring.indexOf(objectToString(tempobj, true)) == -1) {
                                                    if (resultstring == "") {
                                                        if (curtype != "LT_CHARACTER") {
                                                            resultstring += "You cannot remove " + objectToString(tempobj, true)
                                                                    + ".  You need to remove " + objectToString(checkobj, true);
                                                        } else {
                                                            resultstring += locname + " cannot remove " + objectToString(tempobj, true)
                                                                    + ".  " + locname + " will need to remove " + objectToString(checkobj, true);
                                                        }
                                                    } else
                                                        resultstring += " and " + objectToString(checkobj, true);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (!bOkayToWear) {
                        resultstring += " first.";
                        (window as any).AddTextToRTF?.(resultstring + "\r\n", "Black", "Regular");
                    } else {
                        if (curtype != "LT_CHARACTER") {
                            (window as any).AddTextToRTF?.("You take off " + objectToString(tempobj, true) + ".\r\n", "Black", "Regular");
                        } else {
                            (window as any).AddTextToRTF?.(locname + " takes off " + objectToString(tempobj, true) + ".\r\n", "Black", "Regular");
                        }
                        tempobj.bWorn = false;
                    }
                }
                break;
            }
            case "CT_ITEM_LAYERED_WEAR": {
                const tempobj = Finder.object(part2);
                if (tempobj != null && TheGame) {
                    const curtype = tempobj.locationtype;
                    const locname = tempobj.locationname;
                    let bOkayToWear = true;
                    let resultstring = "";
                    if (tempobj.LayeredZoneLevels) {
                        for (let i = 0; i < tempobj.LayeredZoneLevels.length; i++) {
                            const str = tempobj.LayeredZoneLevels[i];
                            const Zonelevel = str.split(":");
                            for (let j = 0; j < TheGame.Objects.length; j++) {
                                const checkobj = TheGame.Objects[j];
                                if (checkobj.bWorn && checkobj.locationtype == curtype) {
                                    if (checkobj.LayeredZoneLevels) {
                                        for (let k = 0; k < checkobj.LayeredZoneLevels.length; k++) {
                                            const str2 = checkobj.LayeredZoneLevels[k];
                                            const checkZoneLevel = str2.split(":");
                                            if (checkZoneLevel[0] == Zonelevel[0]
                                                    && parseInt(checkZoneLevel[1], 10) >= parseInt(Zonelevel[1], 10)) {
                                                if (curtype == "LT_CHARACTER") {
                                                    if (locname != checkobj.locationname)
                                                        continue;
                                                }
                                                bOkayToWear = false;
                                                if (resultstring.indexOf(objectToString(tempobj, true)) == -1) {
                                                    if (resultstring == "") {
                                                        if (curtype != "LT_CHARACTER") {
                                                            resultstring += "You cannot wear " + objectToString(tempobj, true)
                                                                    + ".  You will need to remove " + objectToString(checkobj, true);
                                                        } else {
                                                            resultstring += locname + " cannot wear " + objectToString(tempobj, true)
                                                                    + ".  " + locname + " will need to remove " + objectToString(checkobj, true);
                                                        }
                                                    } else
                                                        resultstring += " and " + objectToString(checkobj, true);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (!bOkayToWear) {
                        resultstring += " first.";
                        (window as any).AddTextToRTF?.(resultstring + "\r\n", "Black", "Regular");
                    } else {
                        if (curtype != "LT_CHARACTER") {
                            (window as any).AddTextToRTF?.("You put on " + objectToString(tempobj, true) + ".\r\n", "Black", "Regular");
                        } else {
                            (window as any).AddTextToRTF?.(locname + " puts on " + objectToString(tempobj, true) + ".\r\n", "Black", "Regular");
                        }
                        tempobj.bWorn = true;
                    }
                }
                break;
            }
            case "CT_DISPLAYTEXT": {
                const allowHtml = Boolean((commandBeingProcessed as any).AllowHtml);
                const suppressParagraph = Boolean((commandBeingProcessed as any).NoParagraphWrapper);
                if ((commandBeingProcessed as any).IsAdvanced && (Settings as any).debugEnabled) {
                    const mainTextEl = $dom('#MainText').get(0);
                    // eslint-disable-next-line no-console
                    console.debug('[AdvancedAction] displayText', {
                        text: cmdtxt,
                        allowHtml,
                        suppressParagraph,
                        hasMainText: Boolean(mainTextEl),
                    });
                }
                const addText = (window as any).AddTextToRTF || AddTextToRTF;
                const textToAdd = suppressParagraph ? cmdtxt : cmdtxt + "</br>";
                addText?.(textToAdd, "Black", "Regular", allowHtml, { suppressParagraph });
                break;
            }
            case "CT_DEBUGTEXT": {
                if ((Settings as any).debugEnabled) console.debug(cmdtxt);
                break;
            }
            case "CT_ENDGAME": {
                AddTextToRTF(cmdtxt + "\r\n", "Black", "Regular");
                (window as any).GameUI?.showMessage?.('EndGame', { type: 'warning', timeout: 5.0 });
                (window as any).GameUI?.hideGameElements?.();
                Globals.endGame = true;
                return true;
            }
            case "CT_MOVEITEMTOINV": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon) {
                        Tempobj = objectBeingActedUpon;
                    }
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    Tempobj.locationtype = "LT_PLAYER";
                }
                (window as any).GameUI?.refreshInventory?.();
                break;
            }
            case "CT_ITEMS_MOVE_CONTAINER_TO_CONTAINER": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon) {
                        Tempobj = objectBeingActedUpon;
                    }
                } else {
                    Tempobj = Finder.object(part2);
                }
                let Destobj: any = null;
                if (part3 == SelfObjectGuid) {
                    if (objectBeingActedUpon) {
                        Destobj = objectBeingActedUpon;
                    }
                } else {
                    Destobj = Finder.object(part3);
                }
                if (Tempobj != null && Destobj != null && TheGame) {
                    for (let i = 0; i < TheGame.Objects.length; i++) {
                        const anObj = TheGame.Objects[i];
                        if (anObj.locationtype == "LT_IN_OBJECT" && anObj.locationname == Tempobj.UniqueIdentifier) {
                            anObj.locationname = Destobj.UniqueIdentifier;
                        }
                    }
                }
                break;
            }
            case "CT_ITEM_SET_VISIBILITY": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    if (part3 == "Visible")
                        Tempobj.bVisible = true;
                    else
                        Tempobj.bVisible = false;
                    (window as any).GameUI?.refreshPanelItems?.();
                }
                break;
            }
            case "CT_MOVEINVENTORYTOCHAR": {
                Interactables.inventoryObjects().forEach((obj) => {
                    obj.locationtype = "LT_CHARACTER";
                    obj.locationname = part2;
                });
                break;
            }
            case "CT_MOVEINVENTORYTOROOM": {
                Interactables.inventoryObjects().forEach((obj) => {
                    if (part2 == CurrentRoomGuid) {
                        if (TheGame) {
                            obj.locationtype = "LT_ROOM";
                            obj.locationname = TheGame.Player.CurrentRoom || "";
                        }
                    } else if (part2 == VoidRoomGuid || part2 === '<Void>') {
                        obj.locationtype = "LT_NULL";
                    } else {
                        obj.locationtype = "LT_ROOM";
                        obj.locationname = part2;
                    }
                });
                break;
            }
            case "CT_MOVECHARINVTOPLAYER": {
                const tempchar = Finder.character(part2);
                if (tempchar != null && TheGame) {
                    for (let i = 0; i < TheGame.Objects.length; i++) {
                        const obj = TheGame.Objects[i];
                        if (obj.locationtype == "LT_CHARACTER" && obj.locationname == tempchar.Charname && obj.bCarryable && obj.bVisible) {
                            obj.locationtype = "LT_PLAYER";
                        }
                    }
                }
                break;
            }
            case "CT_ROOM_MOVE_ITEMS_TO_PLAYER": {
                let temproom: any = null;
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                } else {
                    temproom = Finder.room(part2);
                }
                if (temproom != null && TheGame) {
                    for (let i = 0; i < TheGame.Objects.length; i++) {
                        const obj = TheGame.Objects[i];
                        if (obj.locationtype == "LT_ROOM" && obj.locationname == temproom.UniqueID && obj.bCarryable && obj.bVisible) {
                            obj.locationtype = "LT_PLAYER";
                        }
                    }
                }
                break;
            }
            case "CT_DISPLAYROOMDESCRIPTION": {
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) {
                        const room = Finder.room(TheGame.Player.CurrentRoom);
                        if (room) (window as any).AddTextToRTF?.(room.Description + "\r\n", "Black", "Regular");
                    }
                } else {
                    const temproom = Finder.room(part2);
                    if (temproom != null)
                        (window as any).AddTextToRTF?.(temproom.Description + "\r\n", "Black", "Regular");
                }
                break;
            }
            case "CT_CHAR_DISPLAYPORT": {
                const tempchar = Finder.character(part2);
                if (tempchar != null) {
                    (window as any).showImage?.(tempchar.CharPortrait);
                }
                break;
            }
            case "CT_DISPLAYROOMPICTURE": {
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) {
                        const currentroom = Finder.room(TheGame.Player.CurrentRoom);
                        if (currentroom) (window as any).showImage?.(currentroom.RoomPic);
                    }
                } else {
                    const temproom = Finder.room(part2);
                    if (temproom != null) {
                        (window as any).showImage?.(temproom.RoomPic);
                    }
                }
                break;
            }
            case "CT_MOVEITEMTOROOM": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    Tempobj.locationtype = "LT_ROOM";
                    if (part3 == CurrentRoomGuid) {
                        if (TheGame) Tempobj.locationname = TheGame.Player.CurrentRoom || "";
                    } else if (part3 == VoidRoomGuid || part3 === '<Void>') {
                        Tempobj.locationtype = "LT_NULL";
                    } else {
                        const temp = Finder.room(part3);
                        if (temp != null)
                            Tempobj.locationname = temp.UniqueID;
                    }
                }
                break;
            }
            case "CT_MOVEITEMTOOBJ": {
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon) {
                        const locationobj = Finder.object(part3);
                        if (locationobj) {
                            objectBeingActedUpon.locationtype = "LT_IN_OBJECT";
                            objectBeingActedUpon.locationname = locationobj.UniqueIdentifier;
                        }
                    }
                } else {
                    const tempobj = Finder.object(part2);
                    if (tempobj != null) {
                        const locationobj = Finder.object(part3);
                        if (locationobj) {
                            tempobj.locationtype = "LT_IN_OBJECT";
                            tempobj.locationname = locationobj.UniqueIdentifier;
                        }
                    }
                }
                break;
            }
            case "CT_MOVEITEMTOCHAR": {
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon) {
                        objectBeingActedUpon.locationtype = "LT_CHARACTER";
                        objectBeingActedUpon.locationname = part3;
                    }
                } else {
                    const tempobj = Finder.object(part2);
                    if (tempobj != null) {
                        tempobj.locationtype = "LT_CHARACTER";
                        tempobj.locationname = part3;
                    }
                }
                break;
            }
            case "CT_SETEXIT": {
                const temproom = Finder.room(part2);
                if (temproom != null) {
                    const index = part3.indexOf('-');
                    const tempdir = part3.substring(0, index);
                    const nextindex = part3.indexOf('-', index + 1);
                    let active = "";
                    if (nextindex > -1)
                        active = part3.substring(index + 1, nextindex);
                    else
                        active = part3.substring(index + 1);
                    active = active.trim();
                    const bsetactive = active == "Active";
                    for (let j = 0; j < temproom.Exits.length; j++) {
                        if (temproom.Exits[j].Direction == tempdir) {
                            temproom.Exits[j].bActive = bsetactive;
                        }
                    }
                    (window as any).SetExits?.();
                }
                break;
            }
            case "CT_SETEXITDESTINATION": {
                const temproom = Finder.room(part2);
                if (temproom != null) {
                    let tempexit: any = null;
                    for (let j = 0; j < temproom.Exits.length; j++) {
                        if (temproom.Exits[j].Direction == part3) {
                            tempexit = temproom.Exits[j];
                        }
                    }
                    if (tempexit != null) {
                        if (part4 == "<None>") {
                            tempexit.DestinationRoom = "";
                            tempexit.bActive = false;
                        } else {
                            const destroom = Finder.room(part4);
                            if (destroom != null) {
                                tempexit.DestinationRoom = destroom.UniqueID;
                                tempexit.bActive = true;
                            }
                        }
                    }
                    (window as any).SetExits?.();
                }
                break;
            }
            case "CT_EXECUTETIMER": {
                const temptimer = Finder.timer(part2);
                if (temptimer != null) {
                    temptimer.TurnNumber = 0;
                    await GameTimers.runSingleTimerAsync(temptimer, false);
                }
                break;
            }
            case "CT_RESETTIMER": {
                const temptimer = Finder.timer(part2);
                if (temptimer != null) {
                    temptimer.TurnNumber = 0;
                    (temptimer as any)._wasReset = true;
                }
                break;
            }
            case "CT_SETTIMER": {
                const temptimer = Finder.timer(part2);
                if (temptimer != null) {
                    if (part3 == "Active") {
                        temptimer.Active = true;
                    } else {
                        temptimer.Active = false;
                    }
                }
                break;
            }
            case "CT_SETITEMDESC": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    Tempobj.description = cmdtxt;
                }
                break;
            }
            case "CT_SETPLAYERDESC": {
                if (TheGame) TheGame.Player.Description = cmdtxt;
                break;
            }
            case "CT_VARIABLE_SET_WITH_ROOMPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const cheatFreezes = (window as any).cheatFreezes;
                    if (cheatFreezes && cheatFreezes.variables && cheatFreezes.variables[tempvar.varname]) {
                        break; // Variable is frozen
                    }
                    const splits = part3.split(":");
                    let ValueToSet = "";
                    if (splits.length == 2) {
                        const roomname = splits[0];
                        const propname = splits[1];
                        let temproom: any = null;
                        if (roomname == "<CurrentRoom>") {
                            if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                        } else {
                            temproom = Finder.room(roomname);
                        }
                        if (temproom != null) {
                            for (let i = 0; i < temproom.CustomProperties.length; i++) {
                                const curprop = temproom.CustomProperties[i];
                                if (curprop.Name == propname) {
                                    ValueToSet = curprop.Value;
                                }
                            }
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    varArrayCheck(tempvar, varindex, 'CT_VARIABLE_SET_WITH_ROOMPROPERTYVALUE');
                    const replacedstring = PerformTextReplacements(part4, null);
                    const idx = typeof varindex === 'number' ? varindex : parseInt(String(varindex), 10);
                    const idx1a = typeof varindex1a === 'number' ? varindex1a : parseInt(String(varindex1a), 10);
                    if (tempvar.vartype == "VT_STRINGARRAY" || tempvar.vartype == "VT_STRING") {
                        if (idx == -1)
                            tempvar.sString = ValueToSet;
                        else if (idx1a != -1 && tempvar.VarArray)
                            tempvar.VarArray[idx][idx1a] = ValueToSet;
                        else if (tempvar.VarArray)
                            tempvar.VarArray[idx] = ValueToSet;
                    } else if (tempvar.vartype == "VT_NUMBER" || tempvar.vartype == "VT_NUMBERARRAY") {
                        if (idx == -1)
                            tempvar.dNumType = typeof ValueToSet === 'number' ? ValueToSet : parseFloat(String(ValueToSet));
                        else if (idx1a != -1 && tempvar.VarArray)
                            tempvar.VarArray[idx][idx1a] = ValueToSet;
                        else if (tempvar.VarArray)
                            tempvar.VarArray[idx] = ValueToSet;
                    }
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_TIMERPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const splits = part3.split(":");
                    let ValueToSet = "";
                    if (splits.length == 2) {
                        const roomname = splits[0];
                        const propname = splits[1];
                        const temproom = Finder.timer(roomname);
                        if (temproom != null) {
                            for (let i = 0; i < temproom.CustomProperties.length; i++) {
                                const curprop = temproom.CustomProperties[i];
                                if (curprop.Name == propname) {
                                    ValueToSet = curprop.Value;
                                }
                            }
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex, varindex1a, ValueToSet, ValueToSet, "Equals");
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_VARIABLEPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const splits = part3.split(":");
                    let ValueToSet = "";
                    if (splits.length == 2) {
                        const roomname = splits[0];
                        const propname = splits[1];
                        const temproom = Finder.variable(roomname);
                        if (temproom != null) {
                            for (let i = 0; i < temproom.CustomProperties.length; i++) {
                                const curprop = temproom.CustomProperties[i];
                                if (curprop.Name == propname) {
                                    ValueToSet = curprop.Value;
                                }
                            }
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex, varindex1a, ValueToSet, ValueToSet, "Equals");
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_CHARPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const splits = part3.split(":");
                    let ValueToSet = "";
                    if (splits.length == 2) {
                        const roomname = splits[0];
                        const propname = splits[1];
                        const temproom = Finder.character(roomname);
                        if (temproom != null) {
                            for (let i = 0; i < temproom.CustomProperties.length; i++) {
                                const curprop = temproom.CustomProperties[i];
                                if (curprop.Name == propname) {
                                    ValueToSet = curprop.Value;
                                }
                            }
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex, varindex1a, ValueToSet, ValueToSet, "Equals");
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_ITEMPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const splits = part3.split(":");
                    let ValueToSet = "";
                    if (splits.length == 2) {
                        const roomname = splits[0];
                        const propname = splits[1];
                        let tempitem: any = null;
                        if (roomname == "<Self>") {
                            if (objectBeingActedUpon) {
                                tempitem = objectBeingActedUpon;
                            }
                        } else {
                            tempitem = Finder.object(roomname);
                        }
                        if (tempitem != null) {
                            for (let i = 0; i < tempitem.CustomProperties.length; i++) {
                                const curprop = tempitem.CustomProperties[i];
                                if (curprop.Name == propname) {
                                    ValueToSet = curprop.Value;
                                }
                            }
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex, varindex1a, ValueToSet, ValueToSet, "Equals");
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_PLAYERPROPERTYVALUE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null && TheGame) {
                    let ValueToSet = "";
                    const propname = part3;
                    for (let i = 0; i < TheGame.Player.CustomProperties.length; i++) {
                        const curprop = TheGame.Player.CustomProperties[i];
                        if (curprop.Name == propname) {
                            ValueToSet = curprop.Value;
                        }
                    }
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex, varindex1a, ValueToSet, ValueToSet, "Equals");
                }
                break;
            }
            case "CT_ROOM_SET_CUSTOM_PROPERTY":
            case "CT_ROOM_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const splits = part2.split(":");
                if (splits.length == 2) {
                    const roomname = splits[0];
                    const property = splits[1];
                    let temproom: any = null;
                    if (roomname == "<CurrentRoom>") {
                        if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                    } else {
                        temproom = Finder.room(roomname);
                    }
                    if (temproom != null) {
                        for (let j = 0; j < temproom.CustomProperties.length; j++) {
                            const curprop = temproom.CustomProperties[j];
                            if (curprop != null) {
                                if (curprop.Name == property) {
                                    if (commandBeingProcessed.cmdtype == "CT_ROOM_SET_CUSTOM_PROPERTY_JS") {
                                        const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                        replacedstring = String(temp);
                                    }
                                    SetCustomProperty(curprop, part3, replacedstring, temproom.UniqueID);
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "CT_TIMER_SET_CUSTOM_PROPERTY":
            case "CT_TIMER_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const splits = part2.split(":");
                if (splits.length == 2) {
                    const roomname = splits[0];
                    const property = splits[1];
                    const temproom = Finder.timer(roomname);
                    if (temproom != null) {
                        for (let j = 0; j < temproom.CustomProperties.length; j++) {
                            const curprop = temproom.CustomProperties[j];
                            if (curprop != null) {
                                if (curprop.Name == property) {
                                    if (commandBeingProcessed.cmdtype == "CT_TIMER_SET_CUSTOM_PROPERTY_JS") {
                                        const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                        replacedstring = String(temp);
                                    }
                                    SetCustomProperty(curprop, part3, replacedstring, temproom.Name);
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "CT_VARIABLE_SET_CUSTOM_PROPERTY":
            case "CT_VARIABLE_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const splits = part2.split(":");
                if (splits.length == 2) {
                    const roomname = splits[0];
                    const property = splits[1];
                    const temproom = Finder.variable(roomname);
                    if (temproom != null) {
                        for (let j = 0; j < temproom.CustomProperties.length; j++) {
                            const curprop = temproom.CustomProperties[j];
                            if (curprop != null) {
                                if (curprop.Name == property) {
                                    if (commandBeingProcessed.cmdtype == "CT_VARIABLE_SET_CUSTOM_PROPERTY_JS") {
                                        const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                        replacedstring = String(temp);
                                    }
                                    SetCustomProperty(curprop, part3, replacedstring, temproom.varname);
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "CT_ITEM_SET_CUSTOM_PROPERTY":
            case "CT_ITEM_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const splits = part2.split(":");
                if (splits.length == 2) {
                    const itemname = splits[0];
                    const property = splits[1];
                    let tempitem: any = null;
                    if (itemname == "<Self>") {
                        if (objectBeingActedUpon) {
                            tempitem = objectBeingActedUpon;
                        }
                    } else {
                        tempitem = Finder.object(itemname);
                    }
                    if (tempitem != null) {
                        for (let j = 0; j < tempitem.CustomProperties.length; j++) {
                            const curprop = tempitem.CustomProperties[j];
                            if (curprop != null) {
                                if (curprop.Name == property) {
                                    if (commandBeingProcessed.cmdtype == "CT_ITEM_SET_CUSTOM_PROPERTY_JS") {
                                        const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                        replacedstring = String(temp);
                                    }
                                    SetCustomProperty(curprop, part3, replacedstring, tempitem.UniqueIdentifier);
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "CT_CHAR_SET_CUSTOM_PROPERTY":
            case "CT_CHAR_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const splits = part2.split(":");
                if (splits.length == 2) {
                    const roomname = splits[0];
                    const property = splits[1];
                    const temproom = Finder.character(roomname);
                    if (temproom != null) {
                        for (let j = 0; j < temproom.CustomProperties.length; j++) {
                            const curprop = temproom.CustomProperties[j];
                            if (curprop != null) {
                                if (curprop.Name == property) {
                                    if (commandBeingProcessed.cmdtype == "CT_CHAR_SET_CUSTOM_PROPERTY_JS") {
                                        const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                        replacedstring = String(temp);
                                    }
                                    SetCustomProperty(curprop, part3, replacedstring, temproom.Charname);
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "CT_PLAYER_SET_CUSTOM_PROPERTY":
            case "CT_PLAYER_SET_CUSTOM_PROPERTY_JS": {
                let replacedstring = PerformTextReplacements(part4, null);
                const property = part2;
                if (TheGame) {
                    for (let j = 0; j < TheGame.Player.CustomProperties.length; j++) {
                        const curprop = TheGame.Player.CustomProperties[j];
                        if (curprop != null) {
                            if (curprop.Name == property) {
                                if (commandBeingProcessed.cmdtype == "CT_PLAYER_SET_CUSTOM_PROPERTY_JS") {
                                    const temp = await evalLegacyCustomPropertyJavascriptAsync(replacedstring, curprop.Value);
                                    replacedstring = String(temp);
                                }
                                SetCustomProperty(curprop, part3, replacedstring, 'player');
                            }
                        }
                    }
                }
                break;
            }
            case "CT_VARIABLE_SET_JAVASCRIPT":
            case "CT_SETVARIABLE": {
                let bJavascript = false;
                if (commandBeingProcessed.cmdtype == "CT_VARIABLE_SET_JAVASCRIPT")
                    bJavascript = true;
                let bArraySet = false;
                const arrayvarindex = part2.indexOf("Array:");
                if (arrayvarindex > -1) {
                    bArraySet = true;
                    part2 = part2.substring(arrayvarindex + "Array:".length);
                }
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex1a = GetArrayIndex(part2, 1);
                    let replacedstring = PerformTextReplacements(part4, null);
                    const replacedCmdtxt = PerformTextReplacements(cmdtxt, null);
                    let jsresult: any = null;
                    if (bJavascript) {
                        if (replacedstring == "")
                            replacedstring = replacedCmdtxt;
                        jsresult = await evalJankyJavascriptAsync(replacedstring);
                        if (!bArraySet && jsresult != null)
                            replacedstring = String(jsresult);
                    }
                    await SetVariable(tempvar, bArraySet, bJavascript, varindex, varindex1a, replacedstring, replacedCmdtxt, part3);
                }
                break;
            }
            case "CT_VARIABLE_SET_WITH_VARIABLE": {
                const tempvar = Finder.variable(part2);
                const modifyingvar = Finder.variable(part4);
                if (tempvar != null && modifyingvar != null) {
                    const varindex = GetArrayIndex(part4, 0);
                    const varindex4a = GetArrayIndex(part4, 1);
                    varArrayCheck(modifyingvar, varindex, 'CT_VARIABLE_SET_WITH_VARIABLE');
                    let modifyval: any = "";
                    const idx = typeof varindex === 'number' ? varindex : parseInt(String(varindex), 10);
                    const idx4a = typeof varindex4a === 'number' ? varindex4a : parseInt(String(varindex4a), 10);
                    if (idx == -1) {
                        modifyval = modifyingvar.dNumType;
                    } else {
                        if (idx4a != -1 && modifyingvar.VarArray)
                            modifyval = modifyingvar.VarArray[idx][idx4a];
                        else if (modifyingvar.VarArray)
                            modifyval = modifyingvar.VarArray[idx];
                    }
                    const varindex2 = GetArrayIndex(part2, 0);
                    const varindex2a = GetArrayIndex(part2, 1);
                    await SetVariable(tempvar, false, false, varindex2, varindex2a, modifyval, modifyval, part3);
                }
                break;
            }
            case "CT_DISPLAYVARIABLE": {
                const tempvar = Finder.variable(part2);
                if (tempvar != null) {
                    const varindex = GetArrayIndex(part2, 0);
                    const varindex2a = GetArrayIndex(part2, 1);
                    varArrayCheck(tempvar, varindex, 'CT_DISPLAYVARIABLE');
                    const idx = typeof varindex === 'number' ? varindex : parseInt(String(varindex), 10);
                    const idx2a = typeof varindex2a === 'number' ? varindex2a : parseInt(String(varindex2a), 10);
                    if (tempvar.vartype == "VT_DATETIME" || tempvar.vartype == "VT_DATETIMEARRAY") {
                        let dtDateTime: string;

                        if (tempvar.vartype == "VT_DATETIMEARRAY") {
                            if (idx != -1) {
                                if (idx2a != -1) {
                                    dtDateTime = tempvar.VarArray![idx][idx2a];
                                } else {
                                    dtDateTime = tempvar.VarArray![idx];
                                }
                            } else {
                                break;
                            }
                        } else {
                            dtDateTime = tempvar.dtDateTime;
                        }

                        const dateMoment = (window as any).DateTimes.stringDateToMoment(dtDateTime);

                        if (part3 == "Display Date & Time") {
                            AddTextToRTF(dateMoment.format('dddd, MMMM, DD YYYY hh:mm:ss A') + "\r\n", "Black", "Regular");
                        } else if (part3 == "Display Date Only") {
                            AddTextToRTF(dateMoment.format('dddd, MMMM, DD YYYY') + "\r\n", "Black", "Regular");
                        } else if (part3 == "Display Time Only") {
                            AddTextToRTF(dateMoment.format('hh:mm:ss A') + "\r\n", "Black", "Regular");
                        } else if (part3 == "Display Weekday Only") {
                            AddTextToRTF(dateMoment.format('dddd') + "\r\n", "Black", "Regular");
                        }

                    } else if (tempvar.vartype == "VT_NUMBER" || tempvar.vartype == "VT_NUMBERARRAY") {
                        let dNumType: number | string;

                        if (tempvar.vartype == "VT_NUMBERARRAY") {
                            if (idx != -1) {
                                if (idx2a != -1) {
                                    dNumType = tempvar.VarArray![idx][idx2a];
                                } else {
                                    dNumType = tempvar.VarArray![idx];
                                }
                            } else {
                                break;
                            }
                        } else {
                            dNumType = tempvar.dNumType;
                        }

                        AddTextToRTF(dNumType.toString() + "\r\n", "Black", "Regular");

                    } else if (tempvar.vartype == "VT_STRINGARRAY") {
                        if (idx != -1 && tempvar.VarArray) {
                            if (idx2a != -1)
                                (window as any).AddTextToRTF?.(String(tempvar.VarArray[idx][idx2a]) + "\r\n", "Black", "Regular");
                            else
                                (window as any).AddTextToRTF?.(String(tempvar.VarArray[idx]) + "\r\n", "Black", "Regular");
                        }
                    } else if (tempvar.vartype == "VT_STRING") {
                        (window as any).AddTextToRTF?.(tempvar.sString + "\r\n", "Black", "Regular");
                    }
                }
                break;
            }
            case "CT_CHAR_SETPORT": {
                const tempchar = Finder.character(part2);
                if (tempchar != null) {
                    tempchar.CharPortrait = part3;
                }
                break;
            }
            case "CT_SETROOMPIC": {
                let temproom: any = null;
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                } else {
                    temproom = Finder.room(part2);
                }
                if (temproom != null) {
                    temproom.RoomPic = part3;
                    if (TheGame && temproom == Finder.room(TheGame.Player.CurrentRoom)) {
                        (window as any).showImage?.(temproom.RoomPic);
                    }
                }
                break;
            }
            case "CT_SETROOMLAYEREDPIC": {
                // As RAGS: room is the current-room GUID, a room id or a name;
                // "<None>" clears the layer.
                let temproom: any = null;
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                } else {
                    temproom = Finder.room(part2);
                }
                if (temproom != null) {
                    temproom.LayeredRoomPic = part3 == "<None>" ? "" : part3;
                    if (TheGame && temproom == Finder.room(TheGame.Player.CurrentRoom)) {
                        (window as any).refreshRoomLayeredPicture?.();
                    }
                }
                break;
            }
            case "CT_SETPLAYERPORTRAIT": {
                if (TheGame) {
                    TheGame.Player.PlayerPortrait = part2;
                    (window as any).SetPortrait?.(part2);
                }
                break;
            }
            case "CT_SETLAYEREDPLAYERPORTRAIT": {
                // As RAGS: sets the layer drawn over the portrait (the portrait
                // itself is unchanged); "<None>" clears it.
                if (TheGame) {
                    TheGame.Player.PlayerLayeredImage = part2 == "<None>" ? "" : part2;
                    (window as any).SetPortrait?.(TheGame.Player.PlayerPortrait);
                }
                break;
            }
            case "CT_DISPLAYLAYEREDPICTURE": {
                (window as any).showLayeredPicture?.(part2);
                break;
            }
            case "CT_DISPLAYPICTURE": {
                (window as any).showImage?.(part2);
                break;
            }
            case "CT_MM_SET_BACKGROUND_MUSIC": {
                (window as any).GameUI?.playBgMusic?.((window as any).imagePath?.(part2));
                if (TheGame) TheGame.bgMusic = part2;
                break;
            }
            case "CT_MM_STOP_BACKGROUND_MUSIC": {
                (window as any).GameUI?.playBgMusic?.(null);
                if (TheGame) TheGame.bgMusic = '';
                break;
            }
            case "CT_MM_PLAY_SOUNDEFFECT": {
                (window as any).GameUI?.playSoundEffect?.((window as any).imagePath?.(part2));
                break;
            }
            case "CT_MM_SET_UD_COMPASS": {
                (window as any).ImageRecorder?.sawImage?.(part2);
                css($dom(".compass-up-down"), "background-image", (window as any).imageUrl?.(part2) || "");
                break;
            }
            case "CT_MM_SET_MAIN_COMPASS": {
                (window as any).ImageRecorder?.sawImage?.(part2);
                css($dom(".compass-rose"), "background-image", (window as any).imageUrl?.(part2) || "");
                break;
            }
            case "CT_SETOBJECTACTION": {
                let tempobj: any = null;
                let actionlist: any = null;
                if (part2 == SelfObjectGuid) {
                    if (Globals.objectBeingActedUpon != undefined) {
                        actionlist = Globals.objectBeingActedUpon.Actions;
                    }
                } else {
                    tempobj = Finder.object(part2);
                    if (tempobj) {
                        actionlist = tempobj.Actions;
                    }
                }
                if (actionlist != null) {
                    const actname = part3.substring(0, part3.lastIndexOf('-'));
                    const active = part3.substring(part3.lastIndexOf('-') + 1);
                    const tempact = Finder.action(actionlist, actname);
                    if (tempact != null) {
                        if (active == "Active") {
                            tempact.bActive = true;
                        } else {
                            tempact.bActive = false;
                        }
                    }
                }
                break;
            }
            case "CT_SETCHARACTION": {
                const tempobj = Finder.character(part2);
                if (tempobj != null) {
                    const actname = part3.substring(0, part3.lastIndexOf('-'));
                    const active = part3.substring(part3.lastIndexOf('-') + 1);
                    const tempact = Finder.action(tempobj.Actions, actname);
                    if (tempact != null) {
                        if (active == "Active") {
                            tempact.bActive = true;
                        } else {
                            tempact.bActive = false;
                        }
                    }
                }
                break;
            }
            case "CT_CHAR_SET_GENDER": {
                const tempobj = Finder.character(part2);
                if (tempobj != null) {
                    tempobj.CharGender = part3;
                }
                break;
            }
            case "CT_CHAR_SET_NAME": {
                const tempobj = Finder.character(part2);
                if (tempobj != null) {
                    tempobj.CharnameOverride = part4;
                }
                break;
            }
            case "CT_ROOM_SET_NAME_OVERRIDE": {
                const tempobj = Finder.room(part2);
                if (tempobj != null) {
                    tempobj.SDesc = part4;
                }
                break;
            }
            case "CT_ITEM_SET_NAME_OVERRIDE": {
                const tempobj = Finder.object(part2);
                if (tempobj != null) {
                    tempobj.sdesc = part4;
                }
                break;
            }
            case "CT_SETPLAYERACTION": {
                if (TheGame) {
                    const actname = part3.substring(0, part3.lastIndexOf('-'));
                    const active = part3.substring(part3.lastIndexOf('-') + 1);
                    const tempact = Finder.action(TheGame.Player.Actions, actname);
                    if (tempact != null) {
                        if (active == "Active") {
                            tempact.bActive = true;
                        } else {
                            tempact.bActive = false;
                        }
                    }
                }
                break;
            }
            case "CT_SETROOMACTION": {
                const tempobj = Finder.room(part2);
                if (tempobj != null) {
                    const actname = part3.substring(0, part3.lastIndexOf('-'));
                    const active = part3.substring(part3.lastIndexOf('-') + 1);
                    const tempact = Finder.action(tempobj.Actions, actname);
                    if (tempact != null) {
                        if (active == "Active") {
                            tempact.bActive = true;
                        } else {
                            tempact.bActive = false;
                        }
                    }
                }
                break;
            }
            case "CT_SETLOCKEDUNLOCKED": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    if (part3 == "Locked") {
                        Tempobj.bLocked = true;
                    } else {
                        Tempobj.bLocked = false;
                    }
                }
                break;
            }
            case "CT_SETOPENCLOSED": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    if (part3 == "Open") {
                        Tempobj.bOpen = true;
                    } else {
                        Tempobj.bOpen = false;
                    }
                    (window as any).GameUI?.refreshRoomObjects?.();
                }
                break;
            }
            case "CT_SETITEMTOWORN": {
                let Tempobj: any = null;
                if (part2 == SelfObjectGuid) {
                    if (objectBeingActedUpon)
                        Tempobj = objectBeingActedUpon;
                } else {
                    Tempobj = Finder.object(part2);
                }
                if (Tempobj != null) {
                    if (part3 == "Worn") {
                        Tempobj.bWorn = true;
                    } else {
                        Tempobj.bWorn = false;
                    }
                }
                break;
            }
            case "CT_DISPLAYCHARDESC": {
                const char = Finder.character(part2);
                if (char) (window as any).AddTextToRTF?.(char.Description + "\r\n", "Black", "Regular");
                break;
            }
             case "CT_MOVECHAR": {
                const tempchar = Finder.character(part2);
                if (tempchar != null && TheGame) {
                    if (tempchar.CurrentRoom == TheGame.Player.CurrentRoom) {
                        const tempact = Finder.action(tempchar.Actions, "<<On Character Leave>>");
                        if (tempact != null)
                            await GameActions.processActionAsync(tempact, true);
                    }
                    if (part3 == CurrentRoomGuid) {
                        tempchar.CurrentRoom = TheGame.Player.CurrentRoom || "";
                        const tempact = Finder.action(tempchar.Actions, "<<On Character Enter>>");
                        if (tempact != null)
                            await GameActions.processActionAsync(tempact, true);
                    } else if (part3 == VoidRoomGuid || part3 === '<Void>') {
                        tempchar.CurrentRoom = VoidRoomGuid;
                    } else {
                        if (part3 == "") {
                            (window as any).showAlert?.("Error", "Error in command CT_MoveChar.  Could not locate a room called " + part3);
                            break;
                        }
                        const room = Finder.room(part3);
                        if (room) {
                            tempchar.CurrentRoom = room.UniqueID;
                            if (room == Finder.room(TheGame.Player.CurrentRoom)) {
                                const tempact = Finder.action(tempchar.Actions, "<<On Character Enter>>");
                                if (tempact != null)
                                    await GameActions.processActionAsync(tempact, true);
                            }
                        }
                    }
                    (window as any).GameUI?.refreshCharacters?.();
                }
                break;
            }
             case "CT_MOVEPLAYER": {
                await movePlayerToRoomAsync(part2);
                break;
            }
            case "CT_MOVETOCHAR": {
                const tempchar = Finder.character(part2);
                if (tempchar != null) {
                    if (tempchar.CurrentRoom != VoidRoomGuid && tempchar.CurrentRoom != CurrentRoomGuid) {
                        await movePlayerToRoomAsync(tempchar.CurrentRoom);
                    }
                }
                break;
            }
            case "CT_MOVETOOBJ": {
                const tempobj = Finder.object(part2);
                if (tempobj != null) {
                    if (tempobj.locationtype == "LT_ROOM") {
                        await movePlayerToRoomAsync(tempobj.locationname);
                    }
                }
                break;
            }
                case "CT_CHAR_MOVETOOBJ": {
                const tempchar = Finder.character(part2);
                const tempobj = Finder.object(part3);
                if (tempobj != null && tempchar != null) {
                    if (tempobj.locationtype == "LT_ROOM") {
                        const room = Finder.room(tempobj.locationname);
                        if (room) tempchar.CurrentRoom = room.UniqueID;
                    }
                    if (TheGame && TheGame.Player.CurrentRoom == tempobj.locationname)
                        await RoomChangeAsync(false, false);
                }
                break;
            }
            case "CT_SETCHARDESC": {
                const char = Finder.character(part2);
                if (char) char.Description = cmdtxt;
                break;
            }
            case "CT_SETROOMDESCRIPTION": {
                let temproom: any = null;
                if (part2 == CurrentRoomGuid) {
                    if (TheGame) temproom = Finder.room(TheGame.Player.CurrentRoom);
                } else {
                    temproom = Finder.room(part2);
                }
                if (temproom != null)
                    temproom.Description = cmdtxt;
                break;
            }
            case "CT_JAVA_SET_RAGS": {
                const replacedCmdtxt = PerformTextReplacements(cmdtxt, null);
                const jsresult = await evalJankyJavascriptAsync(replacedCmdtxt);
                (window as any).SetRagsObjectsFromJavascript?.(jsresult);
                break;
            }
           case "CT_SETVARIABLE_NUMERIC_BYINPUT": {
                const acttype = part2;
                if (acttype == "Custom") {
                    (window as any).GameUI?.setCmdInputForCustomChoices?.(part4, commandBeingProcessed);
                } else if (acttype == "Text") {
                    (window as any).GameUI?.showTextMenuChoice?.(part4);
                }

                const globalsIndex = Globals.store({
                    variableGettingSet: commandBeingProcessed,
                });
                await gameController.startAwaitingInputAsync();
                Globals.restore(globalsIndex);
                break;
            }
           case "CT_SETVARIABLEBYINPUT": {
                const acttype = part2;

                const globalsIndex = Globals.store({
                    variableGettingSet: commandBeingProcessed,
                });

                if (acttype == "Custom") {
                    (window as any).GameUI?.setCmdInputForCustomChoices?.(part4, commandBeingProcessed);
                } else  if (acttype == "Text") {
                    (window as any).GameUI?.showTextMenuChoice?.(part4);
                } else {
                    (window as any).GameUI?.clearCmdInputChoices?.();

                    if (acttype == "Character" || acttype == "Characters") {
                        (window as any).GameUI?.addCharacterOptions?.();
                    } else if (acttype == "Object" || acttype == "Objects") {
                        (window as any).GameUI?.addObjectOptions?.();
                    } else if (acttype == "Inventory") {
                        function addChildObjects(parentObject: any) {
                            if (!parentObject.bContainer) {
                                return;
                            }

                            if (TheGame) {
                                TheGame.Objects.forEach((innerObject: any) => {
                                    if (objectContainsObject(parentObject, innerObject)) {
                                        (window as any).GameUI?.addCmdInputChoice?.(
                                            objectToString(innerObject),
                                            innerObject
                                        );
                                        addChildObjects(innerObject);
                                    }
                                });
                            }
                        }

                        if (TheGame) {
                            TheGame.Objects.forEach((obj: any) => {
                                if (obj.locationtype == "LT_PLAYER") {
                                    (window as any).GameUI?.addCmdInputChoice?.(
                                        objectToString(obj),
                                        obj
                                    );
                                    addChildObjects(obj);
                                }
                            });
                        }
                    } else if (acttype == "ObjectOrCharacter" || acttype == "Characters And Objects") {
                        (window as any).GameUI?.addObjectOptions?.();
                        (window as any).GameUI?.addCharacterOptions?.(false, true);
                    }
                    (window as any).GameUI?.setCmdInputMenuTitle?.(Globals.actionBeingTaken, part4);
                }

                await gameController.startAwaitingInputAsync();
                Globals.restore(globalsIndex);
                break;
            }
            case "CT_COMMENT": {
                break;
            }

            /* Internal commands (arguments are in CustomChoices) */

            /** This command is put just before a loop condition when this is not
             * the first iteration in order to set the loop arguments.
             */
            case "CT_REGALIA_LOOPARGS": {
                Globals.loopArgs = commandBeingProcessed.CustomChoices[0];
                Globals.loopArgsValid = true;
                // loopArgsValid will be unset by the loop condition
                break;
            }
            case "CT_REGALIA_ADVANCED_SCRIPT": {
                const action = commandBeingProcessed.CustomChoices?.[0] as any;
                if (action && action.AdvancedScript) {
                    await AdvancedActions.executeAdvancedAction(action, objectBeingActedUpon);
                }
                break;
            }

            default: {
                console.log('Unknown command ' + commandBeingProcessed.cmdtype);
            }
        }
    },

       processConditionAsync: async function (wrappedCondition: any, loopObj: any): Promise<any[] | undefined> {
        const conditionBeingProcessed = wrappedCondition;
        const act = Globals.actionBeingTaken;

        let nextCommands: any[] | undefined;
        if (await GameConditions.testConditionAsync(conditionBeingProcessed, act, loopObj)) {
            if (conditionBeingProcessed.Checks.length === 1 && (window as any).isLoopCheck?.(conditionBeingProcessed.Checks[0])) {
                return undefined;
            } else {
                nextCommands = conditionBeingProcessed.PassCommands;
            }
        } else {
            nextCommands = conditionBeingProcessed.FailCommands;
        }
        return nextCommands;
    },

    runCommandsAsync: async function (commands: any[]): Promise<boolean> {
        let bResult = false;
        for(const commandOrCondition of commands) {
            if(Globals.endGame) return true;

            if (typeof commandOrCondition === "function") {
                console.warn('Callback in command list', commandOrCondition);
                commandOrCondition();
                continue;
            }

            const loopObj = Globals.loopArgs.object;
            const curtype = getObjectClass(commandOrCondition);
            if (curtype == "command" || "CommandName" in commandOrCondition) {
                const commandBeingProcessed = commandOrCondition;

                const part2 = PerformTextReplacements(commandBeingProcessed.CommandPart2, loopObj);
                const part3 = PerformTextReplacements(commandBeingProcessed.CommandPart3, loopObj);
                const part4 = PerformTextReplacements(commandBeingProcessed.CommandPart4, loopObj);
                const cmdtxt = PerformTextReplacements(commandBeingProcessed.CommandText, loopObj);
                (window as any).Logger?.logExecutingCommand?.(commandBeingProcessed, part2, part3, part4);
                try {
                    const stop = await this.runSingleCommandAsync(commandBeingProcessed, part2, part3, part4, cmdtxt);
                    if (stop) {
                        return true;
                    }
                } catch (err: any) {
                    console.warn(err);
                    (window as any).showAlert?.("Command Error", err.message);
                    (window as any).showAlert?.("Command Error", "Rags can not process the command correctly.  If you are the game author, please correct the error in this command: " + commandBeingProcessed.cmdtype);
                }
            } else {
                const nextCommands = await this.processConditionAsync(commandOrCondition, loopObj);
                if (nextCommands) {
                    await this.runCommandsAsync(nextCommands);
                }
            }
        }
        (window as any).GameUI?.refreshInventory?.();
        (window as any).GameUI?.refreshRoomObjects?.();
        (window as any).SetupStatusBars?.();
        return bResult;
    },

};

// Make available globally
(window as any).GameCommands = GameCommands;
